import { QuotasRequestOptions } from 'features/hubspot/types'
import { ReactNode, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import QuotaExceededModal from './QuotaExceededModal/QuotaExceededModal'
import { Alert, Button } from '@carto/meridian-ds/components'

interface QuotaMoreInfoModalProps {
  open?: boolean
  quotasRequestType?: QuotasRequestOptions
  onCloseModal: () => void
}
export interface QuotaAlertProps {
  message: ReactNode
  showMoreInfo?: boolean
  moreInfoModal?: React.FC<QuotaMoreInfoModalProps>
  quotasRequestType?: QuotasRequestOptions
}

function QuotaAlert({ message, showMoreInfo = true, moreInfoModal, quotasRequestType }: QuotaAlertProps) {
  const [open, setOpen] = useState<boolean>(false)

  const MoreInfoModal = moreInfoModal || QuotaExceededModal

  return (
    <>
      <Alert
        severity="warning"
        action={
          showMoreInfo && (
            <Button variant="text" color="inherit" size="small" onClick={() => setOpen(true)}>
              <FormattedMessage id="quotas.warning.button" />
            </Button>
          )
        }
        sx={{ mb: 3 }}
      >
        {message}
      </Alert>

      {showMoreInfo && (
        <MoreInfoModal quotasRequestType={quotasRequestType} open={open} onCloseModal={() => setOpen(false)} />
      )}
    </>
  )
}

export default QuotaAlert
